module.exports = __webpack_public_path__ + "static/media/apercu-light_italic.b13f5044.woff";